"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.initializeHashUpdateManager = exports.HashUpdateManager = void 0;
class HashUpdateManager {
    /**
     * Initialize with optional offset
     */
    static init(offset = 0) {
        this.offset = offset;
        document.addEventListener('DOMContentLoaded', () => {
            const elements = document.querySelectorAll('[data-update-hash-when-focused]');
            if (!elements.length)
                return;
            this.handleIntersect();
            window.addEventListener('scroll', () => this.handleIntersect());
            window.addEventListener('resize', () => this.handleIntersect());
        });
    }
    static handleIntersect() {
        var _a;
        const elements = document.querySelectorAll('[data-update-hash-when-focused]');
        if (elements.length === 0)
            return;
        let candidate = null;
        let candidateDistance = -Infinity;
        elements.forEach(el => {
            const rect = el.getBoundingClientRect();
            const top = rect.top;
            // Use the configurable offset here
            if (top <= this.offset && top > candidateDistance) {
                candidate = el;
                candidateDistance = top;
            }
        });
        if (!candidate)
            candidate = elements[0];
        const newHash = (_a = candidate.dataset.updateHashValue) !== null && _a !== void 0 ? _a : candidate.id;
        if (!newHash || this.currentHash === newHash)
            return;
        this.currentHash = newHash;
        history.replaceState(null, '', `#${newHash}`);
        window.dispatchEvent(new HashChangeEvent('hashchange'));
    }
}
exports.HashUpdateManager = HashUpdateManager;
HashUpdateManager.currentHash = null;
HashUpdateManager.offset = 0;
function initializeHashUpdateManager(offset = 0) {
    HashUpdateManager.init(offset);
}
exports.initializeHashUpdateManager = initializeHashUpdateManager;
